























import { Component, Vue, Watch } from 'vue-property-decorator';
import { ICartCourse, ILoginCredentials, IParentProfile, IStudentListItem, IPaypalItem, ICalendarSession, IPriceTier, ICalendar, IStudentListCartItem } from '@/interfaces';
import { CartGetters, UserGetters } from '@/Getters';
import { AjaxHelper } from '@/AjaxHelper';

import CartStep from './steps/Cart.vue';
import StudentStep from './steps/Student.vue';
import FinalizeStep from './steps/Finalize.vue';

@Component({
  name: 'cart-details-page',
  components: { CartStep, StudentStep, FinalizeStep }
})
export default class CartDetailsComponent extends Vue {
  public get cartItems(): ICartCourse[] { return this.$store.getters[CartGetters.getCourses]; }
  
  public tab: 'cart' | 'student' | 'finalize' = 'cart';
  public sessions: Record<string, ICalendarSession[]> = {};
  public priceTiers: Record<string, IPriceTier[]> = {};

  public async mounted() {
    let sessions: number[] = [];

    const sessionMap: Record<string, ICalendarSession[]> = {};
    for (let i = 0; i < this.cartItems.length; ++i) {
      const session = (await AjaxHelper.get<any>(`/sessionmanagement/${this.cartItems[i].moodleId}`)).sessions as ICalendarSession[]
      sessions = sessions.concat(session.map(x => x.id as number));
      sessionMap[this.cartItems[i].moodleId] = session;
    }
    this.sessions = sessionMap;

    sessions = sessions.filter((x, i) => sessions.indexOf(x) === i);
    const priceTierMap: Record<string, IPriceTier[]> = {};
    for (let i = 0; i < sessions.length; ++i) {
      priceTierMap[sessions[i]] = await AjaxHelper.get(`/pricetier/${sessions[i]}`);
    }
    this.priceTiers = priceTierMap;
  }
}
